/** Must match backend `Settings.max_dataset_upload_bytes` default. */
export const MAX_DATASET_UPLOAD_BYTES = 50 * 1024 * 1024;

/** Must match backend upload suffix check in `routes_datasets.py`. */
export const ALLOWED_DATASET_UPLOAD_SUFFIXES = [
  '.parquet',
  '.csv',
  '.tsv',
  '.geojson',
  '.json',
  '.zip',
  '.gpkg',
  '.kml',
];

export const ALLOWED_DATASET_UPLOAD_ACCEPT = ALLOWED_DATASET_UPLOAD_SUFFIXES.join(',');

export const DATASET_UPLOAD_INVALID_SUFFIX_MESSAGE =
  'Invalid file type. Supported formats: .parquet, .csv, .tsv, .geojson, .json, .zip, .gpkg, .kml';

export function getDatasetUploadSuffix(filename) {
  if (!filename || typeof filename !== 'string') return '';
  const dot = filename.lastIndexOf('.');
  if (dot <= 0) return '';
  return filename.slice(dot).toLowerCase();
}

export function isAllowedDatasetUploadFilename(filename) {
  return ALLOWED_DATASET_UPLOAD_SUFFIXES.includes(getDatasetUploadSuffix(filename));
}

/** @returns {string|null} Error message when invalid, otherwise null. */
export function validateDatasetUploadFilename(filename) {
  if (isAllowedDatasetUploadFilename(filename)) return null;
  return DATASET_UPLOAD_INVALID_SUFFIX_MESSAGE;
}

export function formatDatasetUploadMaxSizeLabel(bytes = MAX_DATASET_UPLOAD_BYTES) {
  if (bytes >= 1024 * 1024 && bytes % (1024 * 1024) === 0) {
    return `${bytes / (1024 * 1024)} MB`;
  }
  if (bytes >= 1024 && bytes % 1024 === 0) {
    return `${bytes / 1024} KB`;
  }
  return `${bytes} bytes`;
}
